import React, { useState } from "react";
import { setSurveyDataToPublish } from "../../../Games/store/GamesSlice";
import { useDispatch } from "react-redux";
import "./CreateSurvey.css";
import { useTranslation } from "react-i18next";
import { setAnchorPosition } from "../../../Map/store/MapDisplaySlice";

const CreateSurvey = ({ onClose }) => {
    const [question, setQuestion] = useState("");
    const [options, setOptions] = useState(["", ""]);
    const [isMultiple, setIsMultiple] = useState(false);
    const [error, setError] = useState(null);

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const handleOptionChange = (index, value) => {
        const newOptions = [...options];
        newOptions[index] = value;
        setOptions(newOptions);
        if (error) setError(null);
    };

    // On passe l'événement 'e' pour stopper la propagation
    const handleAddOption = (e) => {
        e.stopPropagation(); // 🛑 Le clic s'arrête ici
        setOptions([...options, ""]);
    };

    const handleRemoveOption = (e, index) => {
        e.stopPropagation(); // 🛑
        if (options.length > 2) {
            const newOptions = options.filter((_, i) => i !== index);
            setOptions(newOptions);
        }
    };

    const handleTypeChange = (e, value) => {
        e.stopPropagation(); // 🛑
        setIsMultiple(value);
    };

    const handleSubmit = (e) => {
        e.stopPropagation(); // 🛑 Empêche de fermer la modale lors du clic sur "Lancer"

        setError(null);

        if (!question.trim()) {
            setError(t("insert_question"));
            return;
        }
        if (options.some(opt => !opt.trim())) {
            setError(t("fill_questions"));
            return;
        }
        if (options.length < 2) {
            setError(t("min_number_of_questions"));
            return;
        }

        dispatch(setSurveyDataToPublish({
            question,
            options,
            isMultiple
        }));
        dispatch(setAnchorPosition(null));
        onClose();


    };

    const handleCancel = (e) => {
        e.stopPropagation(); // 🛑
        onClose();
    };

    // Protection globale : cliquer dans le vide du formulaire ne doit pas fermer la modale
    const handleContainerClick = (e) => {
        e.stopPropagation();
    };

    return (
        <div
            onClick={handleContainerClick} // Sécurité supplémentaire sur le conteneur
            style={{ padding: "1.25rem", display: "flex", flexDirection: "column", gap: "1.25rem" }}
        >

            {/* QUESTION */}
            <div className="block-form-survey">
                <label style={{ fontWeight: "bold", color: "#334155" }}>
                    {t("your_question")}
                </label>
                <input
                    type="text"
                    placeholder={t("example_question")}
                    value={question}
                    // Pour les inputs, on stoppe aussi souvent la propagation pour éviter des soucis de focus
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => {
                        setQuestion(e.target.value);
                        if (error) setError(null);
                    }}
                    style={{
                        padding: "0.625rem",
                        borderRadius: "0.375rem",
                        border: error && !question.trim() ? "1px solid #ef4444" : "1px solid #cbd5e1",
                        fontSize: "1rem"
                    }}
                />
            </div>

            {/* TYPE DE VOTE */}
            <div className="block-form-survey response-type">
                <label style={{ fontWeight: "bold", color: "#334155" }}>
                    {t("response_type")}
                </label>
                <div style={{ display: "flex", gap: "0.625rem", background: "#EEF2F6", borderRadius: "0.5rem" }}>
                    <button
                        className={!isMultiple && `active`}
                        type="button"
                        onClick={(e) => handleTypeChange(e, false)} // PASSAGE DE L'EVENT
                    >
                        {!isMultiple ?
                            <span class="material-symbols-outlined">
                                check_circle
                            </span>
                            :
                            <span class="material-symbols-outlined">
                                radio_button_unchecked
                            </span>
                        }
                        Unique
                    </button>
                    <button
                        className={isMultiple && `active`}
                        type="button"
                        onClick={(e) => handleTypeChange(e, true)} // PASSAGE DE L'EVENT
                    >
                        {isMultiple ?
                            <span class="material-symbols-outlined">
                                check_circle
                            </span>
                            :
                            <span class="material-symbols-outlined">
                                radio_button_unchecked
                            </span>

                        }
                        Multiples
                    </button>
                </div>
            </div>

            {/* OPTIONS */}
            <div className="block-form-survey">
                <label style={{ fontWeight: "bold", color: "#334155" }}>
                    {t("response_type")}
                </label>

                {options.map((option, index) => (
                    <div className="response-option" key={index}>
                        <input
                            type="text"
                            placeholder={`Option ${index + 1}`}
                            value={option}
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) => handleOptionChange(index, e.target.value)}
                            style={{
                                flex: 1,
                                padding: "0.5rem",
                                borderRadius: "0.375rem",
                                border: error && !option.trim() ? "1px solid #ef4444" : "1px solid #cbd5e1"
                            }}
                        />
                        {options.length > 2 && (
                            <button className="button-response-option"
                                type="button"
                                onClick={(e) => handleRemoveOption(e, index)} // PASSAGE DE L'EVENT
                            >
                                <span class="material-symbols-outlined">
                                    close
                                </span>
                            </button>
                        )}
                    </div>
                ))}

                <button
                    type="button"
                    onClick={handleAddOption} // handleAddOption gère déjà le e.stopPropagation
                    style={{
                        marginTop: "0.3125rem", display: "flex", alignItems: "center", gap: "0.5rem", background: "none",
                        border: "2px dashed #cbd5e1", borderRadius: "0.375rem", padding: "0.5", cursor: "pointer",
                        color: "#64748b", fontWeight: "600", justifyContent: "center"
                    }}
                >
                    <span style={{ fontSize: "1.2rem", lineHeight: "1" }}>+</span>
                     {t("add_option")}
                </button>
            </div>

            {/* ERROR MESSAGE */}
            {error && (
                <div style={{
                    color: "#ef4444", fontSize: "0.9rem", marginTop: "0.3125rem", fontWeight: "500", textAlign: "center",
                    background: "#fef2f2", padding: "0.5rem", borderRadius: "0.375rem", border: "1px solid #fee2e2"
                }}>
                    {error}
                </div>
            )}

            {/* FOOTER */}
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.625rem", marginTop: "0.625rem" }}>
                <button
                    type="button"
                    onClick={handleCancel} // PASSAGE DE L'EVENT (Annuler)
                    style={{ padding: "0.625rem 1.25rem", borderRadius: "0.375rem", border: "1px solid #cbd5e1", background: "white", cursor: "pointer" }}
                >
                    {t("cancel")}
                </button>
                <button
                    className="create-btn"
                    type="button"
                    onClick={handleSubmit} // PASSAGE DE L'EVENT (Lancer)
                >
                    {t("begin_survey")}
                </button>
            </div>

        </div>
    );
};

export default CreateSurvey;